import { render, staticRenderFns } from "./ShuttersDetails.vue?vue&type=template&id=f21f8eae"
import script from "./ShuttersDetails.vue?vue&type=script&lang=ts"
export * from "./ShuttersDetails.vue?vue&type=script&lang=ts"
import style0 from "./ShuttersDetails.vue?vue&type=style&index=0&id=f21f8eae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports